import mobileAdjustment from "../GeneralMobileAdjustments";

class MobileLargeHeadingControlView {

    constructor() {}

    afterRender(control) {
        let element = mobileAdjustment.adjustMobileControl(control);
        mobileAdjustment.setTextsHeight(element);
    }

}
const mobileLargeHeadingControlView = new MobileLargeHeadingControlView();
export default mobileLargeHeadingControlView;